module.exports = __webpack_public_path__ + "img/pro_five_6.f01e506b.jpg";